namespace Nobox {
    export interface DashboardFormModel {
        Template?: number;
        Results?: number;
        Paid?: number;
        Unpaid?: number;
        ByStatus?: { [key: string]: number };
        ByResults?: { [key: string]: number };
        Reccent?: Nobox.NoBoxCRM.FormresultsRow[];
    }
}
